import styled from 'styled-components';

export const AchievementGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-l);
  margin-block: var(--space-xxxl);
  @media screen and (max-width: 1050px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const AchievementCard = styled.div`
  padding: var(--space-l);

  background: var(--white);

  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 20px;

  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.04);

  svg {
    color: var(--orange5);
    font-size: 1.35rem;
    margin-bottom: var(--space-m);
  }

  h4 {
    margin: 0 0 var(--space-xs);

    color: var(--grey7);

    font-size: 1.05rem;
    line-height: 1.3;
    font-weight: 850;
  }

  p {
    margin: 0;

    color: var(--grey4);

    font-size: 0.92rem;
    line-height: 1.7;
    font-weight: 500;
  }
`;
